/**
 * Wahler-Backend
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum TemplateAnalysisRunStatus {

    QUEUED = 'QUEUED',

    RUNNING = 'RUNNING',

    COMPLETED = 'COMPLETED',

    FAILED = 'FAILED'
}

